import type { NavbarLinkProps } from './NavbarLink';
import type { NavbarTextProps } from './NavbarText';

export type ListMenuProps = NavbarLinkProps | NavbarTextProps;

export const listMenu: ListMenuProps[] = [
  {
    title: 'Layanan',
  },
  { label: 'Kehadiran', icon: 'calendar-days', to: '/attendance' },
  {
    label: 'Layanan Mandiri',
    icon: 'square-user-round',
    to: '/ess',
    children: [
      {
        label: 'Absen',
        to: '/ess/absence',
        permissions: [
          'employee_absence.index',
          'employee_absence.show',
          'employee_absence.create',
          'employee_absence.update',
          'employee_absence.delete',
          'employee_absence.approve',
          'employee_absence.reject',
        ],
      },
      {
        label: 'Lembur',
        to: '/ess/overtime',
        permissions: [
          'employee_overtime.index',
          'employee_overtime.show',
          'employee_overtime.create',
          'employee_overtime.update',
          'employee_overtime.delete',
          'employee_overtime.approve',
          'employee_overtime.reject',
        ],
      },
      {
        label: 'Cuti',
        to: '/ess/leave',
        permissions: [
          'employee_leave.index',
          'employee_leave.show',
          'employee_leave.create',
          'employee_leave.update',
          'employee_leave.delete',
          'employee_leave.approve',
          'employee_leave.reject',
        ],
      },
    ],
  },
  {
    label: 'Pelatihan',
    icon: 'tv-minimal-play',
    to: '/employee-training',
    permissions: [
      'employee_training.index',
      'employee_training.show',
      'employee_training.create',
      'employee_training.update',
      'employee_training.delete',
      'employee_training.approve',
      'employee_training.reject',
    ],
  },
  {
    label: 'Penilaian Kinerja',
    icon: 'chart-no-axes-combined',
    to: '/performance-review',
  },
  {
    label: 'Slip Gaji',
    icon: 'scroll-text',
    to: '/salary-slip',
    permissions: [
      'employee_payroll.index',
      'employee_payroll.show',
      'employee_payroll.create',
      'employee_payroll.update',
      'employee_payroll.delete',
    ],
  },
  {
    label: 'Pengembalian Dana',
    icon: 'hand-coins',
    to: '/reimbursement',
    permissions: [
      'reimbursement.index',
      'reimbursement.show',
      'reimbursement.create',
      'reimbursement.update',
      'reimbursement.delete',
    ],
  },
  {
    label: 'Pinjaman',
    icon: 'credit-card',
    to: '/loan',
    permissions: [
      'employee_loan.index',
      'employee_loan.show',
      'employee_loan.create',
      'employee_loan.update',
      'employee_loan.delete',
      'employee_loan.approve',
      'employee_loan.reject',
    ],
  },
  {
    title: 'Data Utama',
  },
  {
    label: 'Kantor',
    icon: 'building-2',
    to: '/master-data/office',
    permissions: ['office.index', 'office.show', 'office.create', 'office.update', 'office.delete'],
  },
  {
    label: 'Sumber Daya Manusia',
    icon: 'book-user',
    to: '/hr',
    children: [
      {
        label: 'Role',
        to: '/hr/role',
        permissions: ['role.index', 'role.show', 'role.create', 'role.update', 'role.delete'],
      },

      {
        label: 'Karyawan',
        to: '/hr/employee',
        permissions: [
          'employee.index',
          'employee.show',
          'employee.create',
          'employee.update',
          'employee.delete',
          'employee.self',
        ],
      },

      {
        label: 'Jabatan',
        to: '/hr/position',
        permissions: [
          'position.index',
          'position.show',
          'position.create',
          'position.update',
          'position.delete',
        ],
      },
      {
        label: 'Unit',
        to: '/hr/unit',
        permissions: ['unit.index', 'unit.show', 'unit.create', 'unit.update', 'unit.delete'],
      },
      {
        label: 'Divisi',
        to: '/hr/division',
        permissions: [
          'division.index',
          'division.show',
          'division.create',
          'division.update',
          'division.delete',
        ],
      },
    ],
  },

  {
    label: 'Keuangan',
    icon: 'wallet',
    to: '/finance',
    children: [
      {
        label: 'Pengembalian Dana',
        to: '/finance/reimbursement',
        permissions: [
          'reimbursement.index',
          'reimbursement.show',
          'reimbursement.create',
          'reimbursement.update',
          'reimbursement.delete',
        ],
      },
      {
        label: 'Komponen Gaji',
        to: '/finance/payroll-component',
        permissions: [
          'payroll_component.index',
          'payroll_component.show',
          'payroll_component.create',
          'payroll_component.update',
          'payroll_component.delete',
        ],
      },
    ],
  },

  {
    label: 'Persetujuan',
    icon: 'file-check-2',
    to: '/approval',
    children: [
      {
        label: 'Shift',
        to: '/approval/shift',
        permissions: ['shift.index', 'shift.show', 'shift.create', 'shift.update', 'shift.delete'],
      },
      {
        label: 'Pelatihan',
        to: '/approval/training',
        permissions: [
          'training.index',
          'training.show',
          'training.create',
          'training.update',
          'training.delete',
          'training.approve',
          'training.reject',
        ],
      },
      {
        label: 'Tipe Absen',
        to: '/approval/absence-type',
        permissions: [
          'employee_absence_type.index',
          'employee_absence_type.show',
          'employee_absence_type.create',
          'employee_absence_type.update',
          'employee_absence_type.delete',
        ],
      },
      {
        label: 'Tipe Cuti',
        to: '/approval/leave-type',
        permissions: [
          'employee_leave_type.index',
          'employee_leave_type.show',
          'employee_leave_type.create',
          'employee_leave_type.update',
          'employee_leave_type.delete',
        ],
      },
    ],
  },
];
